import { useContext, useLayoutEffect, useEffect, useState } from 'react';
import { Redirect, Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { ContextoUsuario } from '../contextos/usuario/ProvedorUsuario';
import Api from '../functions/api';
import Home from '../pages/Home';
import Instituicao from '../pages/Instituicao';
import InstituicaoFormulario from '../pages/Instituicao/Formulario';
import Login from '../pages/Login';
import Solicitacao from '../pages/Solicitacao';
import SolicitacaoFormulario from '../pages/Solicitacao/Formulario';
import FormularioDeSolicitacaoDeEmail from '../pages/SolicitacaoDeEmailInstituicao/FormularioInstitucional';
import FormularioRecusa from '../pages/SolicitacaoDeEmailInstituicao/FormularioRecusa';
import Usuario from '../pages/Usuario';
import UsuarioFormulario from '../pages/Usuario/Formulario';
import { EmailStore } from '../stores/EmailStore';
import AuthenticatedRoute from './AuthenticatedRoute';

function Routes() {
  const [possuiPendecia, atribuirPossuiPendencia] = useState(false);

  const { usuario, sair } = useContext(ContextoUsuario);

  let history = useHistory();

  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const authInterceptor = Api.api.interceptors.request.use(
      async (request) => {
        if (process.env.REACT_APP_AMBIENTE !== 'local') {
          request.headers['Authorization'] = localStorage.getItem('token');
          if (
            !request.headers.Authorization ||
            request.headers.Authorization === 'Bearer undefined'
          ) {
            request = await Api.getToken(request);
          }
          if (usuario) {
            request.headers['Custom-Authorization'] = 'Bearer ' + usuario.tokenString;
          }
          return request;
        } else {
          if (usuario) {
            request.headers['Custom-Authorization'] = 'Bearer ' + usuario.tokenString;
          }
          return request;
        }
      },
      async (err) => {
        if (err.status === 401) {
          sair();
          history.push('/');
          return Promise.reject(err.response);
        }
        return Promise.reject(err.response);
      },
    );

    return () => {
      Api.api.interceptors.request.eject(authInterceptor);
    };
  }, [usuario, history, sair]);

  useEffect(() => {
    if (usuario) {
      usuario.perfil !== 'Administrador' &&
        EmailStore.verificaPossuiPendencia().then((response) => {
          if (response.status === 200) {
            atribuirPossuiPendencia(response.data);
          }
        });
    }
  }, [pathname, usuario]);

  return (
    <>
      <Switch>
        {!usuario && (
          <>
            <Route path='/login' exact>
              <Login />
            </Route>
            <Route path='*'>
              <Redirect to='/login' />
            </Route>
          </>
        )}
        {usuario && (
          <AuthenticatedRoute>
            <Route path='/home' exact>
              <Home />
            </Route>

            {usuario.perfil === 'Administrador' && (
              <>
                <Route path='/solicitacoes' exact>
                  <Solicitacao />
                </Route>
                <Route path='/solicitacao/nova' exact>
                  <SolicitacaoFormulario />
                </Route>
                <Route path='/solicitacao/visualizar/:protocolo' exact>
                  <SolicitacaoFormulario />
                </Route>
                <Route path='/solicitacao/editar/:protocolo' exact>
                  <SolicitacaoFormulario />
                </Route>
                <Route path='/usuario/novo' exact>
                  <UsuarioFormulario />
                </Route>
                <Route path='/usuario' exact>
                  <Usuario />
                </Route>
                <Route path='/instituicao/nova' exact>
                  <InstituicaoFormulario />
                </Route>
                <Route path='/instituicao' exact>
                  <Instituicao />
                </Route>
                <Route path='/instituicao/visualizar/:id' exact>
                  <InstituicaoFormulario />
                </Route>
                <Route path='/instituicao/editar/:id' exact>
                  <InstituicaoFormulario />
                </Route>
                <Route path='/email/recusar/:id'>
                  <FormularioRecusa />
                </Route>
              </>
            )}
            {usuario.perfil !== 'Administrador' && (
              <>
                <Route path='/solicitacoes' exact>
                  {possuiPendecia ? <Redirect to='/home' /> : <Solicitacao />}
                </Route>
                <Route path='/solicitacao/nova' exact>
                  {possuiPendecia ? <Redirect to='/home' /> : <SolicitacaoFormulario />}
                </Route>
                <Route path='/solicitacao/visualizar/:protocolo' exact>
                  {possuiPendecia ? <Redirect to='/home' /> : <SolicitacaoFormulario />}
                </Route>
                <Route path='/solicitacao/editar/:protocolo' exact>
                  {possuiPendecia ? <Redirect to='/home' /> : <SolicitacaoFormulario />}
                </Route>
                <Route path='/usuario'>
                  <Redirect to='/home' />
                </Route>
                <Route path='/instituicao'>
                  <Redirect to='/home' />
                </Route>
                <Route path='/instituicao'>
                  <Redirect to='/home' />
                </Route>
                <Route path='/email/novo/:id'>
                  <FormularioDeSolicitacaoDeEmail />
                </Route>
                <Route path='/email/editar/:id'>
                  <FormularioDeSolicitacaoDeEmail />
                </Route>
              </>
            )}
            <Route path='/' exact>
              <Redirect to='/home' />
            </Route>
            <Route path='/login' exact>
              <Redirect to='/home' />
            </Route>
          </AuthenticatedRoute>
        )}
      </Switch>
    </>
  );
}

export default Routes;
